export default __webpack_public_path__ + "static/handsome-creative-source-separation-systems-277b374d933c4d9af567c97c33923270.gif";